import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-payment-details',
  imports: [NgFor,NgClass],
  templateUrl: './payment-details.component.html',
  styleUrl: './payment-details.component.css'
})
export class PaymentDetailsComponent {
  @Input() ordersData: any[] = [];

  ngOnInit(){
    console.log("payment details",this.ordersData);
  }
}
